module.exports = __webpack_public_path__ + "static/img/line.5e260204.png";